const autoNgTemplateLoaderTemplate1 = require('./resourcePoolAccess.html');

angular.module('shbdeployer.kubernetes').component('kubernetesResourcePoolAccessView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesResourcePoolAccessController',
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
    endpoint: '<',
  },
});
